import React, { Component } from 'react';
import {Field} from 'redux-form';
import {ROUNDS} from '../../constants';

class EventDropDown extends Component {
  render() {
    const { validateFields, input, label, meta: { touched, error }} = this.props;
    const dropdownRounds = ROUNDS.filter((round) => round.id !== "manually-assigned-credentials");

    return (
      <div className={`form-group ${touched && error ? 'has-error' : ''}`}>
        <label>{label}</label>
        <Field component="select" name={input.name} className="form-control" validate={validateFields}>
          <option />
          {Object.keys(dropdownRounds).map(round =>
            <option key={round} value={ROUNDS[round].id}>{ROUNDS[round].name}, {ROUNDS[round].schedule}</option>
          )}
        </Field>
        {(touched && error) && <label id={`${input.name}-error`} className="error" htmlFor={input.name}>{error}</label>}
      </div>
    )
  }
}

export default EventDropDown;



// WEBPACK FOOTER //
// ./src/components/RequestForm/EventDropdown.js